<template>
    <div class="background">
        <div style="background-color: #FFFFFF; width: 100%; height: 90%; margin: 10px 0 10px 10px">
          <div style="margin: 10px 0 20px 20px">
               <div style="font-size: 17px;">
                    <el-col :span="6">票种管理
                    </el-col>
                </div>
                <div class="icon-container">
                    <el-col :span="18">
                        <el-col :span="10" class="style1">
                            <el-input
                                placeholder="票种、项目ID、项目名称"
                                prefix-icon="el-icon-search"
                                v-model="searchId"
                                size="small"
                                @keydown.enter="search"
                                @blur="search"
                                @clear="refresh"
                                clearable
                            >
                            </el-input>
                        </el-col>
                        <el-col :span="9" style="margin-left: 10px;">
                            <div class="icon-container">
                                <!--                                <i class="el-icon-discover">筛选</i>-->
                                <i class="el-icon-date">日期</i>
                                <i class="el-icon-s-promotion">导出</i>
                            </div>

                        </el-col>
                    </el-col>
                </div>
                <div>
                    <el-col :span="9" style="margin-left: 20px; font-size: 15px;" class="haeders">
                        <i> 项目列表</i>
                        <i class="el-icon-folder-add" @click="createTicketType">创建新票种</i>
                    </el-col>
                    <el-col :span="12">
                        状态
                        <el-radio v-model="radio" label="1">全部</el-radio>
                        <el-radio v-model="radio" label="2">项目名称</el-radio>
                        <el-radio v-model="radio" label="3">已上架</el-radio>
                        <el-radio v-model="radio" label="4">待上架</el-radio>
                        <el-radio v-model="radio" label="5">已过期</el-radio>
                    </el-col>
                </div>
          </div>

            <div class="table_container" style="margin-top: 20px">
                <el-table
                    :data="tableData"
                    style="width: 100%"
                     @selection-change="handleSelectionChange"
                >
                  <el-table-column
                    type="selection"
                    width="40">
                </el-table-column>
                    <el-table-column
                        type="index"
                        label="序号"
                        width="50">
                    </el-table-column>
<!--                                        <el-table-column-->
<!--                                            label="项目id"-->
<!--                                            prop="id">-->
<!--                                        </el-table-column>-->
                    <el-table-column
                        width="300"
                        label="内容名称"
                        prop="info">
                    </el-table-column>
                    <el-table-column
                        label="分类"
                        prop="category">
                    </el-table-column>
                    <el-table-column
                        label="价格"
                        prop="price">
                    </el-table-column>
                    <el-table-column
                        label="票种"
                        prop="ticketType"
                        width="100"
                    >
                    </el-table-column>
<!--                    <el-table-column-->
<!--                        label="时间"-->
<!--                        prop="date">-->
<!--                    </el-table-column>-->
                    <el-table-column
                        label="限购"
                        prop="max_num">
                    </el-table-column>
                    <el-table-column
                        label="状态"
                        prop="status">
                    </el-table-column>
                    <el-table-column label="操作" width="200">
                        <template slot-scope="scope">
                           <i class="el-icon-edit" @click="updateTicketType(scope.row)">设置</i>
                            <i class="el-icon-view" @click="getTicketType(scope.row)">查看</i>
                        </template>
                    </el-table-column>
                </el-table>
<!--                <div class="Pagination">-->
<!--                    <el-pagination-->
<!--                        @size-change="handleSizeChange"-->
<!--                        @current-change="handleCurrentChange"-->
<!--                        :current-page="currentPage"-->
<!--                        :page-size="20"-->
<!--                        layout="total, prev, pager, next"-->
<!--                        :total="count">-->
<!--                    </el-pagination>-->
<!--                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
import headTop from '../components/headTop'
import {baseUrl, baseImgPath} from '@/config/env'
import $ from 'jquery'

export default {
    data() {
        return {
            baseUrl,
            baseImgPath,
            ticketTypeList: [
            ],
            searchId: '',
            offset: 0,
            limit: 20,
            count: 0,
            tableData: [],
            multipleSelection: [],
            currentPage: 1,
            selectTable: {},
            dialogFormVisible: false,
            radio: '1',
            id:'',
            selectedRow:''

        }
    },
    created() {
        this.restaurant_id = this.$route.query.restaurant_id;
        // this.initData();
        this.getTicketTypeList()
    },
    computed: {
        specs: function () {
            let specs = [];
            if (this.selectTable.specfoods) {
                this.selectTable.specfoods.forEach(item => {
                    specs.push({
                        specs: item.specs_name,
                        packing_fee: item.packing_fee,
                        price: item.price,
                    })
                })
            }
            return specs
        }
    },
    components: {
        headTop,
    },
    methods: {
          handleSelectionChange(val) {
      this.multipleSelection = val;
    },
        updateTicketType(row){
            console.log(` ${row.id} 条`);
            this.$router.push(`updateTicketType?id=${row.id}`)
        },
        getTicketType(row){
            this.$router.push(`getTicketType?id=${row.id}`)
        },
        search(currentPage) {
            if (currentPage === 0) {
                currentPage = this.pagination.page
            }
            console.log(this.searchId)
            if (!this.searchId) {
                this.getTicketTypeList(0)
            } else {
                this.getTicketTypeList(0)
            }
        },

        refresh() {
            this.searchId = '';
            this.search();
        },
        getTicketTypeList() {
            var selectedValue = localStorage.getItem('selectedValue');
            console.log('请求失败666',selectedValue)
            $.ajax({
                url: this.$settings.BASE_URL+'ticket_type/info',
                type: 'GET',
              data:{"site_id":selectedValue},
                dataType: 'json',
                  xhrFields: {
        withCredentials: true
    },
                success: (res) => {
                    console.log('获取到的数据666：', res)
                    let tableData = []
                    if (res.info == 'ok') {
                        res.ticketTypeList[0].content_info.forEach(function (content) {
                          if(content.ticket_info && content.ticket_info.length >0){
                              content.ticket_info.forEach(function (ticketType){
                            var ticketTypeData = {
                                id: ticketType.id,
                                info: ticketType.name,
                                category: content.content_name,
                                price: ticketType.price,
                                max_num: ticketType.max_num,
                                ticketType:ticketType.ticketType,
                                status: ticketType.status
                            }
                            tableData.push(ticketTypeData)
                          })
                          }
                        })
                        this.tableData = tableData
                    }
                },
                error: (error) => {
                    console.log('请求失败：', error)
                }
            })
        },
        createTicketType() {
            this.$router.push(`createTicketType`)
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.offset = (val - 1) * this.limit;
            this.getResturants()
        },
    },
}
</script>

<style lang="less">
@import '../style/mixin';

.demo-table-expand {
    font-size: 0;
}

.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
}

.table_container {
    padding: 20px;
}

.Pagination {
    display: flex;
    justify-content: flex-start;
    margin-top: 8px;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
}

.avatar {
    width: 120px;
    height: 120px;
    display: block;
}

.el-icon-folder-add {
    width: Hug (138px)px;
    height: Fixed (41px)px;
    top: 149px;
    left: 415px;
    padding: 10px 8px 10px 8px;
    gap: 10px;
    border-radius: 8px;
    border: 1px solid #5C16F2;
    color: #5C16F2;

}

.background {
    background-color: #F4F5FA;
    height: 100vh;
}

.el-icon-discover {
    width: 68px;
    height: 29px;
    border-radius: 4px 4px 4px 4px;
    opacity: 0px;
    border: 1px solid #5C16F2;
    color: #5C16F2;
    text-align: center;
    justify-items: center;
}

.el-icon-date {
    width: 68px;
    height: 29px;
    border-radius: 4px 4px 4px 4px;
    opacity: 0px;
    border: 1px solid #5C16F2;
    color: #5C16F2;
    text-align: center;
    justify-items: center;
}

.el-icon-s-promotion {
    width: 68px;
    height: 29px;
    border-radius: 4px 4px 4px 4px;
    opacity: 0px;
    border: 1px solid #5C16F2;
    color: #5C16F2;
    text-align: center;
    justify-items: center;
}

.inputStyle {
    border: 1px solid #5C16F2;
    border-radius: 4px 4px 4px 4px;
    color: #5C16F2;
}

.el-icon-search {
    color: #5C16F2;
}

.haeders {
    color: #2D334A;
    font-family: PingFang SC;
    font-weight: 600;
    line-height: 30.8px;
    //text-align: left;
    //text-underline-position: from-font;
    //text-decoration-skip-ink: none;
}

.icon-container {
    display: flex; /* 使用 Flexbox 布局 */
    justify-content: flex-end;
    gap: 10px; /* 设置图标之间的间距 */
}

/* 每个图标的样式 */
.icon-container i {
    display: flex; /* 让每个 i 标签成为 Flexbox 项 */
    align-items: center; /* 垂直居中文本 */
    justify-content: center; /* 水平居中文本 */
    border-radius: 4px; /* 可选：设置圆角 */
    //border: 1px solid #5C16F2; /* 可选：设置边框 */
    color: #5C16F2; /* 设置字体颜色 */
    font-size: 14px; /* 设置字体大小 */
    text-align: center; /* 确保文本水平居中 */
}

.style1 {
    width: Hug (68px) px;
    height: Fixed (29px) px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #5C16F2;
    text-align: center;
    justify-items: center;
    justify-content: center;
    margin: 0 10px 0 10px;
}
.el-icon-edit {
    color: #5C16F2;
}

.el-icon-view {
    color: #5C16F2;
}
.el-input, .el-button {
     margin-top: 0 !important;
}

</style>
